<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '../stores/app';
import { personalInfo } from '../data/portfolio';

const appStore = useAppStore();

const displayBio = computed(() => 
  appStore.isZh ? personalInfo.bio : personalInfo.bioEn
);

const abilities = computed(() => [
  {
    icon: 'fa-code',
    title: appStore.isZh ? '多语言全栈开发' : 'Multi-Language Full Stack',
    desc: appStore.isZh 
      ? '精通多种编程语言，构建端到端解决方案' 
      : 'Proficient in multiple languages, building end-to-end solutions'
  },
  {
    icon: 'fa-brain',
    title: appStore.isZh ? 'AI/ML 算法与应用' : 'AI/ML Algorithms',
    desc: appStore.isZh 
      ? '擅长深度学习模型开发与集成' 
      : 'Specializing in deep learning model development and integration'
  },
  {
    icon: 'fa-eye',
    title: appStore.isZh ? '计算机视觉' : 'Computer Vision',
    desc: appStore.isZh 
      ? '专注于图像识别与分析技术' 
      : 'Focused on image recognition and analysis technology'
  },
  {
    icon: 'fa-server',
    title: appStore.isZh ? '系统架构与优化' : 'System Architecture',
    desc: appStore.isZh 
      ? '设计并实现高并发、可扩展的系统' 
      : 'Designing and implementing high-concurrency, scalable systems'
  },
  {
    icon: 'fa-shield-alt',
    title: appStore.isZh ? '网络安全与渗透测试' : 'Cybersecurity & Pentesting',
    desc: appStore.isZh 
      ? '具备漏洞挖掘与安全防护实践经验' 
      : 'Experienced in vulnerability discovery and security protection'
  }
]);
</script>

<template>
  <section id="about" class="about-section section">
    <div class="container">
      <h2 class="section-title">
        <i class="fas fa-user-ninja"></i>
        {{ appStore.isZh ? '关于我' : 'About Me' }}
      </h2>
      <div class="section-divider"></div>
      <p class="section-subtitle">
        {{ appStore.isZh 
          ? '吾乃代码世界的哪吒，三头六臂，神通广大' 
          : 'I am the Nezha of the coding world, with three heads and six arms' }}
      </p>

      <div class="about-content">
        <div class="about-info">
          <h3 class="info-title">
            <i class="fas fa-scroll"></i>
            {{ appStore.isZh ? '个人简介' : 'Introduction' }}
          </h3>
          <p class="info-bio">{{ displayBio }}</p>

          <div class="abilities-list">
            <div 
              v-for="(ability, index) in abilities" 
              :key="ability.title"
              class="ability-item"
              :style="{ animationDelay: `${0.4 + index * 0.1}s` }"
            >
              <div class="ability-icon">
                <i :class="['fas', ability.icon]"></i>
              </div>
              <div class="ability-text">
                <h4 class="ability-title">{{ ability.title }}</h4>
                <p class="ability-desc">{{ ability.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import '../styles/components/about.css';
</style>
